<template>
  
  <div class="space-y-6">
    <!-- Adet Seçimi -->
    <div class="flex items-center justify-between">
      <span class="text-base font-medium text-gray-700">Adet</span>
      <div class="inline-flex items-center">
        <UButton
          :disabled="quantity <= 1"
          variant="soft"
          color="gray"
          class="!h-9 !w-9 !p-0"
          @click="decreaseQuantity"
        >
          <UIcon name="i-heroicons-minus" class="h-4 w-4" />
        </UButton>
        <div
          class="flex min-w-[2.5rem] select-none items-center justify-center px-2 text-base font-medium"
        >
          {{ quantity }}
        </div>
        <UButton
          :disabled="quantity >= buyboxData.buybox.max_quantity"
          variant="soft"
          color="gray"
          class="!h-9 !w-9 !p-0"
          @click="increaseQuantity"
        >
          <UIcon name="i-heroicons-plus" class="h-4 w-4" />
        </UButton>
      </div>
    </div>

    <!-- Sepete Ekle ve Hemen Al Butonları -->
    <div class="flex flex-col gap-4">
      <UButton
        :loading="addingToCart"
        :disabled="!buyboxData.buybox.stock_status || addingToCart || buyingNow"
        size="xl"
        color="orange"
        variant="solid"
        block
        class="!py-3"
        @click="handleAddToCart"
      >
        <div class="flex items-center justify-center gap-3">
          <UIcon name="i-heroicons-shopping-bag" class="h-6 w-6" />
          <span v-if="buyboxData.buybox.stock_status" class="text-base font-medium tracking-wide"
            >Sepete Ekle</span
          >
          <span v-else class="text-base font-medium tracking-wide"
            >Stokta Yok</span
          >
        </div>
      </UButton>

      <UButton
        v-if="buyboxData.buybox.stock_status"
        :loading="buyingNow"
        :disabled="!buyboxData.buybox.stock_status || addingToCart || buyingNow"
        size="xl"
        color="sky"
        variant="soft"
        block
        class="!py-3"
        @click="handleBuyNow"
      >
        <div class="flex items-center justify-center gap-3">
          <UIcon name="i-heroicons-bolt" class="h-6 w-6" />
          <span class="text-base font-medium tracking-wide">Hemen Al</span>
        </div>
      </UButton>
    </div>
    <!-- Stok Bilgisi -->
    <div v-if="buyboxData.buybox.stock_status && maxQuantity" class="text-center">
      <span class="text-sm font-medium text-gray-500">
        Maksimum {{ maxQuantity }} adet sipariş verebilirsiniz
      </span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  maxQuantity: {
    type: Number,
    required: true
  }
})

const productDetailsStore = useProductDetailsStore()
const productBuyboxStore = useProductBuyboxStore()

const { productDetails } = storeToRefs(productDetailsStore)
const { buyboxData } = storeToRefs(productBuyboxStore)


const cartStore = useCartStore()

// State
const quantity = ref(1)
const addingToCart = ref(false)
const buyingNow = ref(false)

// Methods
const increaseQuantity = () => {
  if (quantity.value < props.maxQuantity) {
    quantity.value++
  }
}

const decreaseQuantity = () => {
  if (quantity.value > 1) {
    quantity.value--
  }
}

// Sepette mevcut ürünü bulma
const findExistingCartItem = () => {
  if (!cartStore.cartItems?.length) return null

  return cartStore.cartItems.find(
    (item) => item.product_id === productDetails.value.id && !item.product_variation_id
  )
}

// Sepete ekleme işlemi
const addToCart = async () => {
  const existingCartItem = findExistingCartItem()

  const response = await cartStore.addToCartForBasic({
    productId: productDetails.value.id,
    quantity:  quantity.value,
    originalPrice: buyboxData.value.buybox.discounted_price,
    originalVendorId: buyboxData.value.buybox.vendor.id,
    cartItemId: existingCartItem?.id
  })

  return response
}

const handleAddToCart = async () => {
  if (addingToCart.value) return
  addingToCart.value = true
  try {
    await addToCart()
  } finally {
    addingToCart.value = false
  }
}

const handleBuyNow = async () => {
  if (buyingNow.value) return
  buyingNow.value = true
  try {
    await addToCart(false)
    navigateTo('/sepet')
  } finally {
    buyingNow.value = false
  }
}

// Reset quantity when product changes
watch(
  () => props.productId,
  () => {
    quantity.value = 1
  }
)
</script>
